import React from "react";
import Papa from "papaparse";

// Step 3
function SavedDataDisplayStep({ savedData }) {
  const handleExportCSV = () => {
    const csvData = savedData.map((data) => ({
      "Person Id": data.id,
      "FootballManager Id": data.footballManagerId,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "saved_data.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-2">Saved Data</h2>
      <button
        onClick={handleExportCSV}
        className="mb-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Export CSV
      </button>
      <div className="relative overflow-x-auto">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                Person Id
              </th>
              <th scope="col" className="px-6 py-3">
                FootballManager Id
              </th>
            </tr>
          </thead>
          <tbody>
            {savedData.map((data) => (
              <tr
                key={data.id}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <td className="px-6 py-4">{data.id}</td>
                <td className="px-6 py-4">{data.footballManagerId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SavedDataDisplayStep;
